import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import imageFallback from './assets/img-not-found.png'

//const apiUrl = process.env.REACT_APP_API_URL;
const MIN_TIME = 0;
const MAX_TIME = 60;
const UNVERIFIED_MEDIA = 0;
const SAFE_MEDIA = 1;
const UNSAFE_MEDIA = 2;

/*      MEDIA FLAGS
        0 - unverified
        1 - safe
        2 - unsafe
*/
function isElementVerified(flag) {

    if (flag > UNVERIFIED_MEDIA) {
        return true;
    } else {
        return false;
    }
}

function isElementSafe(flag) {
    if (flag === SAFE_MEDIA) {
        return true;
    } else if (flag === UNSAFE_MEDIA) {
        return false;
    }
}

const normalizePoster = (url) => {
    if (!url) return imageFallback;
    return url.includes('null') ? imageFallback : url;
};

const reportMovieOptions = Array.from({ length: 61 }, (_, i) => (
    <option key={i} value={i}>{i}</option>
));

const reportTvOptions = Array.from({ length: 21 }, (_, i) => (
    <option key={i} value={i}>{i}</option>
));

const reportHoursOptions = Array.from({ length: 25 }, (_, i) => (
    <option key={i} value={i}>{i}</option>
));

var selectedItem;

function FilmListComponent({ query }) {

    // MODAL HANDLING
    const [data, setData] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const handleShow = (element) => {
        setFirstNumber(0);
        setSecondNumber(0);
        setModalShow(true);
        selectedItem = element;
    }
    const handleClose = () => {
        setModalShow(false);
        selectedItem = null;
    }

    // SEND REPORT HANDLING
    const onReportSend = () => {
        const postData = async () => {
            try {
                const response = await fetch('/api/report', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        db_id: selectedItem.id,
                        media_type: selectedItem.media_type,
                        hours: firstNumber,
                        minutes: secondNumber
                    }),
                });

                const data = await response.json();
                console.log('Response:', data);
            } catch (error) {
                console.error('Error sending data:', error);
            }
        };

        postData();
        setModalShow(false);
        selectedItem = null;
    }

    // REPORT DATA HANDLING
    const [firstNumber, setFirstNumber] = useState(0);
    const [secondNumber, setSecondNumber] = useState(0);
    const handleFirstChange = (event) => {
        if (event.target.value >= MIN_TIME && event.target.value <= MAX_TIME) {
            setFirstNumber(event.target.value);
        } else {
            setFirstNumber(0);
        }
    };
    const handleSecondChange = (event) => {
        if (event.target.value >= MIN_TIME && event.target.value <= MAX_TIME) {
            setSecondNumber(event.target.value);
        } else {
            setSecondNumber(0);
        }
    };

    useEffect(() => {
        var fullUrl = ``;
        if (query) {
            fullUrl = `/api/movies/search?query=${encodeURIComponent(query)}`
        }
        else {
            fullUrl = `/api/movies/trending`
        }
        fetch(fullUrl)
            .then(response => response.json())
            .then(data => {
                setData(data);
            })
            .catch(error => {
                console.error("Fetch error: ", error);
            });

    }, [query])

    return (
        <div className="results">
            {data.length === 0 ? (
                <p>No data found</p>
            ) : (
                <div className="row">
                    {data
                        .filter(el => el.media_type === 'movie' || el.media_type === 'tv')
                        .map((element, id) => (
                            <div className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4" key={id}>
                                <div className="card h-100 bg-dark text-bg-dark text-center position-relative">
                                    <img
                                        src={normalizePoster(element.fullPosterUrl)}
                                        className="card-img-top z-0 position-static"
                                        alt="poster"
                                    />
                                    <div className="card-body">
                                        <p className="card-title">{element.original_name || element.original_title}</p>
                                    </div>
                                    <div className='mt-3 me-3 z-2 position-absolute top-0 end-0'>
                                        {isElementVerified(element.flag) ? (
                                            <div>
                                                {
                                                    isElementSafe(element.flag) ? (
                                                        <div>
                                                            <button class="btn btn-success">Safe</button>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <button class="btn btn-danger">Unsafe</button>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        ) : (
                                            <div>
                                                <button type="button"
                                                    class="btn btn-warning"
                                                    onClick={() => handleShow(element)}
                                                >
                                                    Report
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}


                    <div>
                        {selectedItem ? (
                            <div>
                                <Modal centered={true} show={modalShow} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Report Form</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <strong>{selectedItem.original_name || selectedItem.original_title}</strong>
                                        {selectedItem.media_type === 'movie' ? (
                                            <div>
                                                <p>Please select timing in <strong>hours</strong> and <strong>minutes</strong> where you have found the LGBTQ+ scene.</p>
                                                <p>This will help us verify your report faster.</p>

                                                <div className="input-group mb-3">
                                                    <label className="input-group-text" htmlFor="inputGroupSelect01">hour</label>
                                                    <select
                                                        id="inputGroupSelect01"
                                                        className="form-select"
                                                        value={firstNumber}
                                                        onChange={handleFirstChange}
                                                    >
                                                        {reportHoursOptions}
                                                    </select>
                                                </div>
                                                <div className="input-group mb-3">
                                                    <label className="input-group-text" htmlFor="inputGroupSelect02">minute</label>
                                                    <select
                                                        id="inputGroupSelect02"
                                                        className="form-select"
                                                        value={secondNumber}
                                                        onChange={handleSecondChange}
                                                    >
                                                        {reportMovieOptions}
                                                    </select>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <p>Please select <strong>season</strong> and <strong>episode</strong> where you have found the LGBTQ+ scene.</p>
                                                <p>This will help us verify your report faster.</p>

                                                <div className="input-group mb-3">
                                                    <label className="input-group-text" htmlFor="inputGroupSelect03">season</label>
                                                    <select
                                                        id="inputGroupSelect03"
                                                        className="form-select"
                                                        value={firstNumber}
                                                        onChange={handleFirstChange}
                                                    >
                                                        {reportTvOptions}
                                                    </select>
                                                </div>
                                                <div className="input-group mb-3">
                                                    <label className="input-group-text" htmlFor="inputGroupSelect04">episode</label>
                                                    <select
                                                        id="inputGroupSelect04"
                                                        className="form-select"
                                                        value={secondNumber}
                                                        onChange={handleSecondChange}
                                                    >
                                                        {reportTvOptions}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                        <p className='mt-3'>If you are not sure, leave 0 in fields</p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>
                                        <Button variant="primary" onClick={onReportSend}>
                                            Report
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        ) : (<div></div>)}
                    </div>
                </div>
            )}
        </div>
    );
}

export default FilmListComponent;
